import { styled } from 'styled-components'

import { Card } from '../../Base/Card'

interface PolicyDetailCardProps {
  children: React.ReactNode
  styles?: string
}

export const POLICY_DETAIL_CARD_HORIZONTAL_PADDING = 48

export function PolicyDetailCard({ children, styles }: PolicyDetailCardProps) {
  return (
    <StyledCard
      noShadow
      padding={`32px ${POLICY_DETAIL_CARD_HORIZONTAL_PADDING}px`}
      align="left"
      styles={styles}
    >
      {children}
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  border-radius: 0;

  &:empty,
  &:has(> *:empty) {
    display: none;
  }
`
